import React from 'react';
import i18n from 'i18next';
import { CurrencyInputLabel } from '@weezevent/nacre';

export default function PriceInput({ value, title, onChange = () => {}, disabled = false, currency, min }) {
    const locale = i18n.language;

    return (
        <CurrencyInputLabel
            label={title}
            currency={currency}
            locale={locale}
            numberDecimals={2}
            min={min}
            value={value}
            disabled={disabled}
            onChange={result => onChange(result.value)}
        />
    );
}
